import React, { Component } from "react";

import AuthenticationActions from "Redux/AuthenticationRedux";
import { FacebookLoginButton } from "react-social-login-buttons";
import LoginForm from "Forms/LoginForm";
import Modal from "react-bootstrap/Modal";
import SocialButton from "Components/SocialButton";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import styled from "styled-components";
import { Fonts } from "Themes";

const MainContainer = styled(Modal.Body)`
  display: flex;
`;

const RightContainer = styled.div`
  text-align: center;
  flex: 1;
  padding: 20px;
`;

const ModalTitle = styled.div`
  font-family: ${Fonts.primaryFontFamily};
  font-size: 30px;
`;

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      socialFacebookError: null,
      fetching: false,
    };
    this.nodes = {};
  }

  setNodeRef(provider, node) {
    if (node) {
      this.nodes[provider] = node;
    }
  }

  handleLoginSuccess = async () => {
    const { getUserDetails, onHide, history } = this.props;
    await getUserDetails();
    history.push(navRoutes.updateFeed);
    onHide();
  };

  handleLoginFailure = (e) => {
    console.log("[ERROR]", e);
    this.setState({
      error: e.detail,
      fetching: false,
    });
  };

  handleSubmit = async (values) => {
    this.setState({
      fetching: true,
    });
    const { login } = this.props;
    const resolve = {
      onSuccess: () => this.handleLoginSuccess(),
      onFailure: (e) => this.handleLoginFailure(e),
    };
    await login(values, resolve);
  };

  handleSocialLoginSuccess = () => {
    this.handleLoginSuccess();
  };

  handleSocialLogin = async (data) => {
    const resolve = {
      onSuccess: () => this.handleSocialLoginSuccess(),
      onFailure: (e) => this.handleSocialLoginFailure(e),
    };
    const socialData = {
      provider: data["_provider"],
      uid: data["_profile"]["id"],
      inputToken: data["_token"]["accessToken"],
      profile: data["_profile"],
    };
    await this.props.socialLogin(socialData, resolve);
  };

  renderFacebookButton = () => {
    return (
      <SocialButton
        provider="facebook"
        appId="261112561181160"
        onLoginSuccess={this.handleSocialLogin}
        onLoginFailure={this.handleSocialLoginFailure}
        onLogoutSuccess={this.onLogoutSuccess}
        getInstance={this.setNodeRef.bind(this, "facebook")}
        key={"facebook"}
        error={this.state.socialFacebookError}
      >
        <FacebookLoginButton />
      </SocialButton>
    );
  };

  render() {
    const { show, onHide, history, title } = this.props;
    const { error, fetching } = this.state;
    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <ModalTitle>{title}</ModalTitle>
        </Modal.Header>
        <MainContainer>
          <RightContainer>
            <LoginForm
              handleSubmit={this.handleSubmit}
              handleNavigation={this.handleNavigation}
              loginError={error}
              fetching={fetching}
              history={history}
              navigateToSignup={() => {
                history.push(navRoutes.signup);
                onHide();
              }}
              forgottenPassword={() => {
                history.push(navRoutes.forgottenPassword);
                onHide();
              }}
            />
          </RightContainer>
        </MainContainer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (data, resolve) =>
      dispatch(AuthenticationActions.loginRequest(data, resolve)),
    socialLogin: (data, resolve) =>
      dispatch(AuthenticationActions.socialAuthLoginRequest(data, resolve)),
    getUserDetails: () =>
      dispatch(AuthenticationActions.getUserDetailsRequest()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginModal);
